import { gql } from 'apollo-angular';

export const INVENTORY_JOBS_QUERY = gql`
  query inventoryJobs(
    $company: Int!
    $status: String
    $olderThanMinutes: Int
    $limit: Int
    $offset: Int
  ) {
    inventoryJobs(
      company: $company
      status: $status
      olderThanMinutes: $olderThanMinutes
      limit: $limit
      offset: $offset
    ) {
      id
      operation
      docType
      docId
      articleId
      docDate
      status
      attempts
      lastError
      createdAt
      doneAt
    }
  }
`;

export const INVENTORY_JOB_COUNTS_QUERY = gql`
  query inventoryJobCounts($company: Int!) {
    inventoryJobCounts(company: $company) {
      pending
      done
      failed
      dismissed
    }
  }
`;

export const RETRY_INVENTORY_JOB_MUTATION = gql`
  mutation retryInventoryJob($company: Int!, $id: ID!) {
    retryInventoryJob(company: $company, id: $id) {
      id
      status
      error
    }
  }
`;

/**
 * Marks a reviewed failure as handled out of band. Returns the same payload
 * shape as the retry mutation, with `status: 'dismissed'` on success and
 * `'not_found'` when the row is not in `failed` (the backend only ever allows
 * `failed` -> `dismissed`).
 */
export const DISMISS_INVENTORY_JOB_MUTATION = gql`
  mutation dismissInventoryJob($company: Int!, $id: ID!) {
    dismissInventoryJob(company: $company, id: $id) {
      id
      status
      error
    }
  }
`;

export const ARTICLE_INVENTORY_WARNINGS_QUERY = gql`
  query articleInventoryWarnings($company: Int!, $articleIds: [Int!]!) {
    articleInventoryWarnings(company: $company, articleIds: $articleIds) {
      articleId
      failedCount
      lastDocType
      lastDocId
      lastFailedAt
    }
  }
`;
